import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoForApp = _resolveComponent("LogoForApp")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'home-page': _ctx.isHomePage,
      'other-page': _ctx.isOtherPage,
      'number-replacement': _ctx.isNumberReplacement,
      'dark-mode': _ctx.isNumberReplacement && _ctx.themeStore.theme === 'dark',
    })
  }, [
    (_ctx.isLogoVisible)
      ? (_openBlock(), _createBlock(_component_LogoForApp, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 2))
}